<template>
  <div>
    <iframe
      v-if="autoLoginToken"
      :src="`https://dpd.talentprint.com/${autoLoginToken}`"
      class="hidden"
    />

    <Header />
    <Testimonials />
  </div>
</template>
<script>
import Header from "./components/Header";
import Testimonials from "./components/Testimonials";
export default {
  name: "Main",
  components: {
    Header,
    Testimonials,
  },
  computed: {
    autoLoginToken() {
      // console.log(this.$store.state.alex.data.youlabToken);
      return this.$store.state.alex.data.youlabToken;
    },
  },
  created() {
    this.$store.commit("SET_PAGE_TYPE", "alex");
    this.$store.commit("SET_PAGE_FOOTER_BACKGROUND_COLOR", "#F7F7F7");
    // console.log(
    //   "Background Color",
    //   this.$store.state.pageFooterBackgroundColor
    // );
  },
};
</script>
